import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/views/layout/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // 切换路由时，自动滚动到顶部
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/quote.html',
      redirect: '/quote'
    },
    {
      path: "/quote",
      component: Layout,
      children: [
        {
          path: '',
          name: 'quoteSmt',
          meta: { title: 'SMT计价', keepCache: false },
          component: () => import('@/views/quoteNew/smt/index.vue')
        },
        {
          path: 'submit',
          name: 'quoteSubmit',
          meta: { title: '提交页', keepCache: false },
          component: () => import('@/views/quoteNew/submit/index.vue')
        },
        {
          path: 'success',
          name: 'quoteSubmitSuccess',
          meta: { title: '提交成功页', keepCache: false },
          component: () => import('@/views/quoteNew/submitSuccess/index.vue')
        }
      ]
    },
    {
      path: '/quote/activity',
      name: 'quoteActivity',
      meta: { title: 'SMT新客双重福利', keepCache: false, hideAsideFixed: true },
      component: () => import('@/views/activity/index.vue')
    }
  ]
})

export default router
